import { useEffect, useState } from "react"
import { useGet } from "../../hooks/useGet"
import { Loader } from "../../ui/loaders/Loader"
import { TeacherNote } from "./TeacherNote"
import { useTranslation } from "react-i18next"
import { GlobalRank } from "./GlobalRank"

export const TableView = ({ studentId, examId }) => {
  const { t } = useTranslation()
  const [examResults, setExamResults] = useState()

  const [student, setStudent] = useState()
  const [examGroupData, setExamGroupData] = useState()

  const { response, error, loading } = useGet(`student/exam/results?student_id=${studentId}&exam_id=${examId}`)

  const calcResult = () => {
    let t = 0
    examResults?.forEach((r) => (t += r.result))
    return t
  }

  const calcExamPoint = () => {
    let t = 0
    examResults?.forEach((examResult) => (t += examResult.tos_question.question_points))
    return t
  }

  useEffect(() => {
    if (response) {
      setExamResults(response.data.student.exam_results)
      setStudent(response.data.student)
      if (response.data?.exam_group_data) {
        setExamGroupData(response.data.exam_group_data)
      }
      if (response.data?.exam_group_data == 0) {
        console.log(response.data.exam_group_data)
        setExamGroupData()
      }
    }
  }, [response])

  return (
    <div>
      {loading && <Loader message={`Please wait`} />}
      {student?.exams.length > 0 && student?.exams[0].exam_note && (
        <TeacherNote notes={student?.exams[0]?.exam_note.notes} />
      )}

      <table className="table table-striped mt-3">
        <thead>
          {examGroupData?.name && (
            <tr className="alert alert-primary">
              <th colSpan={4} className="text-left">
                <GlobalRank examGroupData={examGroupData} />
              </th>
            </tr>
          )}
          <tr>
            <th>
              <span>{response?.data?.information?.course}</span>
              <th></th>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>{t("student_result")}</th>
            <td>{response?.data?.student_total}</td>
            <th>{t("class_average")}</th>
            <td>{response?.data.class_avg}</td>
          </tr>
          <tr>
            <th>{t("rank_in_class")}</th>
            <td>{response?.data.rank_in_class}</td>
            <th>{t("rank_in_classes")}</th>
            <td>{response?.data.rank_in_classes}</td>
          </tr>
          <tr>
            <th>{t("exam_definition")}</th>
            <td>{response?.data.information.exam_definition}</td>
            <th>{t("exam_date")}</th>
            <td>{response?.data.information.exam_date}</td>
          </tr>
        </tbody>
      </table>
      <p className=" fw-bold mt-5">{t("student_below_performance")}</p>
      <table className="table ">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>{student?.full_name} Result</th>
            <th>Question Point</th>
          </tr>
          <tr className="alert alert-primary">
            <th>Q.No</th>
            <th>Subject</th>
            <th>{calcResult()}</th>
            <th>{calcExamPoint()}</th>
          </tr>
        </thead>
        <tbody>
          {examResults?.map((result) => {
            return (
              <tr
                key={result.id}
                className={`${
                  result.result / result.tos_question.question_points < 0.5 ? "table-danger text-danger fw-bold" : ""
                }`}>
                <td>{result?.tos_question?.question_no}</td>
                <td
                  dangerouslySetInnerHTML={{
                    __html: result?.tos_question?.code_definition?.subject,
                  }}></td>
                <td>{result.result}</td>
                <td>{result.tos_question.question_points}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
